import { handleActions } from 'redux-actions'
import { setUser } from './actions'

export const user = handleActions({
  [setUser]: (state, action) => ({
    ...state,
    'user': action.payload
  })
}, {})
